import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Sparkles, MessageCircle, BarChart3, Bell } from 'lucide-react';
import { t } from '../../lib/i18n';

export const buildKpis = (stats) => ([
  { key: 'overallScore', value: stats?.overall_score || 0, suffix: '/100', icon: Sparkles, color: 'var(--lux-gold)' },
  { key: 'sessions', value: stats?.session_count || 0, icon: MessageCircle, color: 'hsl(182,55%,46%)' },
  { key: 'analyses', value: stats?.analysis_count || 0, icon: BarChart3, color: 'hsl(210,60%,56%)' },
  { key: 'reminders', value: stats?.active_reminders || 0, icon: Bell, color: 'hsl(25,80%,60%)' },
]);

const KpiCard = ({ kpi, language }) => {
  const Icon = kpi.icon;
  return (
    <Card className="metric-card bg-lux-panel/90 border-white/[0.08] hover:border-white/15 fade-in" data-testid={`dashboard-kpi-${kpi.key}`}>
      <CardContent className="pt-5 pb-4">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs text-white/40 uppercase tracking-wider mb-1">{t(kpi.key, language)}</p>
            <p className="text-2xl font-bold text-white tabular-nums" data-testid={`dashboard-kpi-${kpi.key}-value`}>
              {kpi.value}{kpi.suffix || ''}
            </p>
          </div>
          <div className="p-2 rounded-lg" style={{ background: `${kpi.color}15` }}>
            <Icon className="w-5 h-5" style={{ color: kpi.color }} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const KpiGrid = ({ stats, language }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="dashboard-kpi-grid">
    {buildKpis(stats).map(kpi => <KpiCard key={kpi.key} kpi={kpi} language={language} />)}
  </div>
);
